import { RoleType } from 'src/mainTypes'
import {
  COMMUNITY_TYPE,
  CommunityMemberPermissionsGroup,
  PermissionActions
} from 'src/client/types'
import { useUser } from 'src/hook/useUser'
import { useUserSessionData } from 'src/hook/useUserSessionData'
import { UseCommunityPermissionsProps } from './useCommunityPermissions.types'

const useCommunityPermissions = (community?: UseCommunityPermissionsProps) => {
  const { viewAsBar } = useUser()
  const { data: user } = useUserSessionData()

  const hasPermission = (permission: PermissionActions, actions?: PermissionActions[]) =>
    Boolean(actions?.some((action) => action === permission))

  const communityPermissions = community?.permissions?.actions
  const isOwner = user?.role === CommunityMemberPermissionsGroup.OWNER
  const isCreator = viewAsBar?.role === RoleType.Creator
  const setUpCommunityPermissions = [
    PermissionActions.MEMBER_ROLE_READ,
    PermissionActions.ACCESS_AND_PRIVACY,
    PermissionActions.BLOCK_READ
  ]

  const canCreateCommunityGroup = isOwner && isCreator
  const canEditCommunityGroup = isOwner && isCreator
  const canDeleteCommunityGroup = isOwner && isCreator
  const canCreateCommunity = isOwner && isCreator
  const canImportCommunity = isOwner && isCreator
  const canSetUpCommunity = setUpCommunityPermissions.some((permission) =>
    hasPermission(permission, communityPermissions)
  )
  const canDeleteCommunity =
    hasPermission(PermissionActions.COLLECTION_DELETE, communityPermissions) &&
    community?.type !== COMMUNITY_TYPE.PAID

  return {
    canCreateCommunityGroup,
    canEditCommunityGroup,
    canDeleteCommunityGroup,
    canCreateCommunity,
    canSetUpCommunity,
    canDeleteCommunity,
    canImportCommunity
  }
}

export default useCommunityPermissions
